<!-- 全局搜索 -->
<template>
	<div class="wrap">

		<div class="header">
			<div class="header-top">
				<img src="../assets/return.png" class="return-img">
				<div class="search-bar">
					<img src="../assets/search-icon2.png" class="search-icon">
					<input type="search" placeholder="请输入关键字进行搜索" class="search-input" />
					<img src="../assets/del.png" class="search-del-icon">
				</div>
				<button type="button" class="search-btn">搜索</button>
			</div>
			<div class="header-bottom">
				<div class="header-bottom-item active">全部</div>
				<div class="header-bottom-item">问答</div>
				<div class="header-bottom-item">视频</div>
				<div class="header-bottom-item">图文</div>
				<div class="header-bottom-item">资料</div>
				<div class="header-bottom-item">新闻</div>
				<div class="header-bottom-item">供应商</div>
				<button type="button" class="filter-button">
					<img src="../assets/icon-183.png">
				</button>
			</div>
		</div>

		<!-- 问答 -->
		<ul class="questions-and-answers-list">
			<li>
				<div class="questions-and-answers-top">
					<div class="questions-and-answers-top-left">
						<img src="../assets/img.png">
						大风起兮
					</div>
					<img src="../assets/icon-84.png" class="questions-and-answers-top-right">
				</div>
				<div class="questions-and-answers-center">
					<img src="../assets/icon-185.png" class="questions-and-answers-center-img">
					<div class="questions-and-answers-center-sidebar">
						<p class="questions-and-answers-center-sidebar-title">
							自己做了四年hr现在需要换工作却迷茫了
						</p>
						<p class="questions-and-answers-center-sidebar-msg">
							不瞒你说，618京东以旧换新，我用电子垃圾免费薅到了一部小米12，一下子省了4千多块钱，不知道怎…
						</p>
						<ul class="item-tag-list">
							<li>咽炎</li>
							<li>阶段检测</li>
						</ul>
					</div>
				</div>
				<div class="questions-and-answers-bottom">
					<div class="questions-and-answers-bottom-left">
						<img src="../assets/icon-184.png">178人回答·1.8K浏览量
					</div>
					<button type="button" class="questions-and-answers-bottom-right">
						<img src="../assets/icon-186.png">
					</button>
				</div>
			</li>
		</ul>

		<!-- 资料 -->
		<ul class="list">
			<li>
				<div class="item-sidebar">
					<div class="item-column">
						<p class="item-name">慢性咽炎的症状和治疗方法</p>
						<!-- <p class="item-msg">咽炎的典型症状是什么 咽炎的症状及治疗方法</p> -->
						<ul class="item-tag-list">
							<li>咽炎</li>
							<li>阶段检测</li>
						</ul>
					</div>
					<!-- <p class="row">
						<img src="../assets/icon-17.png" class="icon">
						{{ item.down_num }}
					</p> -->
					<div class="item-bottom">
						<p class="item-bottom-avatar-row">
							<img src="../assets/img.png">
							<span>搞一下汽车电子</span>
						</p>
						<p class="item-bottom-eye-row">
							<img src="../assets/icon-83.png">
							23.8w
						</p>
						<span class="item-bottom-eye-time">2022-09-12</span>
					</div>
				</div>
				<div class="img-box">
					<img src="../assets/icon-107.png" class="img">
					<img src="../assets/icon-84.png" class="tag">
				</div>
			</li>

		</ul>
		<!-- 图文 -->
		<ul class="list2">
			<li>
				<p class="item-name2">喝酒不得新冠？鉴定12个网络热门传言</p>
				<div class="item">
					<div class="item-sidebar3">
						<p class="item-msg">咽炎的典型症状是什么 咽炎的症状及治疗方法</p>
						<ul class="item-tag-list">
							<li>咽炎</li>
							<li>阶段检测</li>
						</ul>
					</div>
					<div class="img-box3">
						<img src="../assets/img.png" class="img">
						<img src="../assets/icon-84.png" class="tag">
						<span class="img-box-time">图文</span>
					</div>
				</div>
				<div class="item-bottom-image">
					<p class="item-bottom-avatar-row">
						<img src="../assets/img.png">
						<span>搞一下汽车电子</span>
					</p>
					<p class="item-bottom-eye-row">
						<img src="../assets/icon-83.png">
						23.8w
					</p>
					<span class="item-bottom-eye-time">2022-09-12</span>
				</div>
			</li>
		</ul>
		<!-- 视频 -->
		<ul class="sub-list">
			<li>
				<div class="img-box2">
					<img src="../assets/img.png" class="img-box-img">
					<!-- <img src="../assets/video_play_im.png" class="play"> -->
					<img src="../assets/icon-84.png" class="tag">
					<span class="img-box-time">02:34</span>
				</div>
				<div class="item-sidebar2">
					<p class="item-title2">你都是怎么吃布洛芬退烧药的呢？</p>
					<ul class="item-tag-list">
						<li>咽炎</li>
					</ul>
					<div class="item-sidebar-row">
						<img src="../assets/img.png" class="item-sidebar-row-img">
						搞一下汽车电子
					</div>
					<div class="item-sidebar-row-between">
						<div class="item-sidebar-row-left-box">
							<div class="item-sidebar-row-left">
								<img src="../assets/icon-141.png" class="play-icon">
								6.2万
							</div>
							<span class="item-sidebar-row-time">2022-09-23</span>
						</div>
						<button class="circle-btn">
							<img src="../assets/icon-142.png" class="circle-img">
						</button>
					</div>
				</div>

			</li>
		</ul>

		<!-- 新闻 -->
		<ul class="list2">
			<li>
				<p class="item-name2">喝酒不得新冠？鉴定12个网络热门传言</p>
				<div class="item">
					<div class="item-sidebar3">
						<p class="item-msg">咽炎的典型症状是什么 咽炎的症状及治疗方法</p>
						<ul class="item-tag-list">
							<li>咽炎</li>
							<li>阶段检测</li>
						</ul>
					</div>
					<div class="img-box3">
						<img src="../assets/img.png" class="img">
						<img src="../assets/icon-84.png" class="tag">
						<span class="img-box-time">新闻</span>
					</div>
				</div>
				<div class="item-bottom-image">
					<p class="item-bottom-avatar-row">
						<img src="../assets/img.png">
						<span>搞一下汽车电子</span>
					</p>
					<p class="item-bottom-eye-row">
						<img src="../assets/icon-83.png">
						23.8w
					</p>
					<span class="item-bottom-eye-time">2022-09-12</span>
				</div>
			</li>
		</ul>

		<!-- 产品 -->
		<ul class="list2">
			<li>
				<p class="item-name2">喝酒不得新冠？鉴定12个网络热门传言</p>
				<div class="item">
					<div class="item-sidebar3">
						<p class="item-msg">咽炎的典型症状是什么 咽炎的症状及治疗方法</p>
						<ul class="item-tag-list">
							<li>咽炎</li>
							<li>阶段检测</li>
						</ul>
					</div>
					<div class="img-box3">
						<img src="../assets/img.png" class="img">
						<img src="../assets/icon-84.png" class="tag">
						<span class="img-box-time">产品</span>
					</div>
				</div>
				<div class="item-bottom-image">
					<p class="item-bottom-avatar-row">
						<img src="../assets/img.png">
						<span>搞一下汽车电子</span>
					</p>
					<p class="item-bottom-eye-row">
						<img src="../assets/icon-83.png">
						23.8w
					</p>
					<span class="item-bottom-eye-time">2022-09-12</span>
				</div>
			</li>
		</ul>

		<!-- 这个不知道是什么 -->
		<ul class="list2">
			<li>
				<p class="item-name3">喝酒不得新冠？鉴定12个网络热门传言</p>
				<div class="item">
					<div class="img-box4">
						<img src="../assets/img.png" class="img">
						<img src="../assets/icon-84.png" class="tag">
						<span class="img-box-tag">待解决</span>
					</div>
					<div class="item-sidebar4">
						<p class="item-msg">咽炎的典型症状是什么 咽炎的症状及治疗方法</p>
						<ul class="item-tag-list">
							<li>咽炎</li>
							<li>阶段检测</li>
						</ul>
					</div>

				</div>
				<div class="item-bottom-image2">
					<div class="item-bottom-image2-left">
						<p class="item-bottom-avatar-row">
							<img src="../assets/img.png">
							<span>搞一下汽车电子</span>
						</p>
						<p class="item-bottom-eye-row">
							<img src="../assets/icon-83.png">
							23.8w
						</p>
					</div>
					<div class="item-bottom-image2-right">
						出价：<span>944</span>
					</div>
				</div>
			</li>
		</ul>

		<!-- 这个不知道是什么 -->
		<ul class="list2">
			<li>
				<div class="item-top">
					<p class="item-top-name">区块链项目经理</p>
					<span class="item-top-price">30-50K·15薪</span>
				</div>
				<p class="item-top-msg">
					上海埃恪深科技有限公司 · 上市 · 100人
				</p>
				<ul class="item-tag-list">
					<li>咽炎</li>
					<li>阶段检测</li>
				</ul>
				<div class="item-bottom-image3">
					<div class="item-bottom-image2-left">
						<p class="item-bottom-avatar-row">
							<img src="../assets/img.png">
							<span>人力资源·郝先生</span>
						</p>
					</div>
					<div class="item-bottom-image2-right">
						<p class="location-row"><img src="../assets/icon-187.png">北京市·海淀区</p>
					</div>
				</div>
			</li>
		</ul>

		<!-- 商品 -->
		<ul class="list-product">
			<li>
				<div class="img-box-product">
					<img src="../assets/img.png" class="img">
				</div>
				<div class="img-box-product-sidebar">
					<p class="img-box-product-sidebar-title">格午安主食罐头牛肉鸡肉配方营养幼猫奶糕</p>
					<ul class="item-tag-list">
						<li>咽炎</li>
						<li>阶段检测</li>
					</ul>
					<div class="img-box-product-sidebar-between">
						<div class="img-box-product-sidebar-between-row">
							<p class="img-box-product-price">
								¥<span>34.89</span>
							</p>
							<p class="img-box-product-sale">销量984</p>
						</div>
						<img src="../assets/icon-188.png" class="img-box-product-cart">
					</div>
				</div>
			</li>
		</ul>

		<!-- 这个不知道是什么 -->
		<ul class="sub-list">
			<li>
				<div class="img-box2">
					<img src="../assets/img.png" class="img-box-img">
					<!-- <img src="../assets/video_play_im.png" class="play"> -->
					<img src="../assets/icon-84.png" class="tag">
					<span class="img-box-status">进行中</span>
					<span class="img-box-status green">进行中</span>
				</div>
				<div class="item-sidebar2">
					<p class="item-title2">你都是怎么吃布洛芬退烧药的呢？</p>
					<ul class="item-tag-list">
						<li>咽炎</li>
					</ul>
					<div class="item-sidebar-row">
						<img src="../assets/img.png" class="item-sidebar-row-img">
						搞一下汽车电子
					</div>
					<div class="item-sidebar-row-between">
						<div class="item-sidebar-row-left-box">
							<div class="item-sidebar-row-left">
								<img src="../assets/icon-83.png" class="play-icon">
								6.2万
							</div>
							<span class="item-sidebar-row-time">2022-09-23</span>
						</div>
						<button class="circle-btn">
							<img src="../assets/icon-142.png" class="circle-img">
						</button>
					</div>
				</div>

			</li>
		</ul>

		<div class="float-box">
			<button type="button" @click="$router.replace('/contact-online')">没找到？点我反馈</button>
		</div>


		<!-- 回到顶部 -->
		<to-top display-height="0" />

	</div>
</template>

<script>
	import ToTop from "@/components/to-top.vue";
	export default {
		components: {
			ToTop,
		},
		data() {
			return {

			};
		},
		mounted() {},
		methods: {



		},
	}
</script>

<style scoped>
	.header {
		width: 100%;
		height: 80px;
		background: #fff;
		background-size: 100% 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}

	.header-top {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		padding-left: 7px;
		box-sizing: border-box;
	}

	.return-img {
		width: 20px;
		margin-right: 7px;
	}

	.search-bar {
		flex: 1;
		height: 36px;
		background-color: #F4F4F4;
		border-radius: 50px;
		display: flex;
		align-items: center;
		padding: 0 40px 0 14px;
		box-sizing: border-box;
		position: relative;
	}

	.search-icon {
		width: 20px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		color: #222222;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.search-del-icon {
		width: 20px;
		position: absolute;
		right: 14px;
		top: 50%;
		transform: translate(0, -50%);
	}

	.search-btn {
		color: #2A63F3;
		font-size: 16px;
		font-weight: bold;
		width: 55px;
		height: 36px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.header-bottom {
		width: 100%;
		height: 36px;
		white-space: nowrap;
		overflow: auto;
		padding: 0 14px;
		box-sizing: border-box;
		background: #fff;
		position: relative;
	}

	.filter-button {
		position: absolute;
		padding: 0 12px 0 16px;
		height: 36px;
		display: flex;
		justify-content: center;
		align-items: center;
		right: 0;
		top: 0;
		background: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff 40%);
	}

	.filter-button>img {
		width: 18px;
	}

	.header-bottom-item {
		flex: 1;
		height: 36px;
		line-height: 36px;
		display: inline-block;
		color: #444444;
		font-size: 15px;
		position: relative;
		margin-right: 20px;
	}

	.header-bottom-item:last-child {
		margin-right: 0;
	}

	.header-bottom-item.active::after {
		content: "";
		width: 18px;
		height: 2px;
		background-color: #2A63F3;
		border-radius: 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
	}

	.header-bottom-item>img {
		width: 8px;
		margin-left: 2px;
	}

	.header-bottom-item.active {
		color: #2A63F3;
		font-weight: bold;
	}

	.wrap {
		width: 100%;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		background: #F3F3F3;
		padding-bottom: 80px;
		padding-top: 90px;
		box-sizing: border-box;
	}

	.float-box {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFFFFF;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
	}

	.float-box>button {
		width: 181px;
		height: 42px;
		background-color: #2A63F3;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 16px;
		font-weight: bold;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 12px 0;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		background-color: #FFFFFF;
		border-radius: 10px;
		padding: 12px 10px 10px;
		box-sizing: border-box;
	}

	.item {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.img-box {
		width: 74px;
		height: 74px;
		position: relative;
	}

	.img-box .img {
		width: 100%;
		height: 100%;
	}

	.tag {
		position: absolute;
		right: 4px;
		top: 4px;
		width: 26px;
	}

	.item-sidebar {
		flex: 1;
		min-height: 72px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		margin-right: 10px;
	}

	.item-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.item-name {
		width: 100%;
		color: #222222;
		font-size: 16px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		font-weight: bold;
		margin-bottom: 4px;
		/* 	font-weight: bold; */
		/* margin-bottom: 5px; */
	}

	.item-msg {
		width: 100%;
		color: #555555;
		font-size: 13px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		margin-bottom: 5px;
	}

	.row {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #666666;
		font-size: 10px;
	}

	.icon {
		width: 14px;
		margin-bottom: 3px;
	}

	.item-bottom-image {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 6px;
	}

	.item-bottom {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 11px;
	}

	.item-bottom-avatar-row {
		display: flex;
		align-items: center;
		color: #777777;
		font-size: 12px;
		margin-right: 10px;
	}

	.item-bottom-avatar-row>img {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		margin-right: 4px;
	}

	.item-bottom-avatar-row>span {
		max-width: 94px;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.item-bottom-eye-row {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 11px;
	}

	.item-bottom-eye-row>img {
		width: 14px;
		margin-right: 2px;
	}

	.item-bottom-eye-time {
		color: #888888;
		font-size: 11px;
		margin-left: 8px;
	}

	.item-tag-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.item-tag-list>li {
		color: #FF6700;
		font-size: 10px;
		padding: 0 5px;
		height: 16px;
		background-color: #FFF5EB;
		border-radius: 1px;
		width: fit-content;
		margin-right: 6px;
		margin-bottom: 4px;
	}


	/* 图文 */
	.list2 {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 12px 0;
		box-sizing: border-box;
	}

	.list2>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
		background-color: #FFFFFF;
		padding: 0 10px;
		box-sizing: border-box;
		border-radius: 10px;
		padding: 10px;
		box-sizing: border-box;
	}

	.item-title {
		width: 100%;
		/*  height: 38px;
	line-height: 38px; */
		color: #222222;
		font-size: 16px;
		font-weight: bold;
		/*font-weight: bold;*/
		margin: 10px 0 8px;
	}

	.item-title>p {
		/* max-height: 48px !important;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical; */
	}

	.img-box3 {
		width: 120px;
		height: 67px;
		border-radius: 6px;
		overflow: hidden;
		position: relative;
	}

	.img-box3 .img {
		width: 100%;
		height: 100%;
	}

	.item-sidebar3 {
		flex: 1;
		min-height: 67px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		margin-right: 10px;
	}

	.img-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.img-list>li {
		flex: 1;
		position: relative;
		overflow: hidden;
		margin-right: 5px;
	}

	.img-list>li:last-child {
		margin-right: 0;
	}

	.img {
		width: 100%;
		height: 59px;
		object-fit: cover
	}

	.img-max {
		width: 100%;
		height: 110px;
		object-fit: cover
	}

	.img-list>li:first-child>img {
		border-top-left-radius: 7px;
		border-bottom-left-radius: 7px;
	}

	.img-list>li:last-child>img {
		border-top-right-radius: 7px;
		border-bottom-right-radius: 7px;
	}

	.min-img {
		width: 100%;
		height: 59px;
		object-fit: cover
	}

	.item-name2 {
		width: 100%;
		color: #222222;
		font-size: 16px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		font-weight: bold;
		margin-bottom: 8px;
		/* 	font-weight: bold; */
		/* margin-bottom: 5px; */
	}

	/* 视频 */
	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 10px;
		box-sizing: border-box;
		/*height: 100%;*/
		overflow: auto;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 10px;
		margin-bottom: 10px;
		padding: 10px;
		box-sizing: border-box;
		position: relative;
	}

	.img-box2 {
		width: 160px;
		height: 90px;
		position: relative;
		border-radius: 6px;
		overflow: hidden;
		margin-right: 10px;
	}

	.img-box-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img-box2 .play {
		position: absolute;
		top: calc(50% - 9px);
		left: calc(50% - 9px);
		width: 18px;
		height: 18px;
	}

	.img-box2 .video-time {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.img-box2 .tag {
		position: absolute;
		right: 4px;
		top: 4px;
		width: 28px;
	}

	.item-sidebar2 {
		flex: 1;
		min-height: 90px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-title2 {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 16px;
		font-weight: bold;
		line-height: 20px;
		margin-bottom: 3px;
	}

	.item-sidebar-row {
		width: 100%;
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.item-sidebar-row-img {
		width: 12px;
		height: 12px;
		border-radius: 50%;
		margin-right: 4px;
		object-fit: cover;
	}

	.item-sidebar-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 3px;
	}

	.item-sidebar-row-left {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.play-icon {
		width: 12px;
		margin-right: 4px;
	}

	.circle-btn {
		width: 10px;
		height: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.circle-img {
		height: 10px;
	}

	.item-sidebar-row-left-box {
		display: flex;
		align-items: center;
	}

	.item-sidebar-row-time {
		color: #999999;
		font-size: 10px;
		margin-left: 10px;
	}

	.img-box-time {
		color: #FFFFFF;
		font-size: 10px;
		border-radius: 2px;
		background: rgba(0, 0, 0, 0.8);
		height: 16px;
		line-height: 16px;
		padding: 0 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		bottom: 4px;
		right: 4px;
		z-index: 10;
	}

	.questions-and-answers-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 12px 0;
		box-sizing: border-box;
	}

	.questions-and-answers-list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 10px;
		padding: 12px 10px 10px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.questions-and-answers-top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 11px;
	}

	.questions-and-answers-top-left {
		display: flex;
		align-items: center;
	}

	.questions-and-answers-top-left>img {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		margin-right: 6px;
	}

	.questions-and-answers-top-right {
		width: 26px;
	}

	.questions-and-answers-center {
		width: 100%;
		display: flex;
		align-items: flex-start;
	}

	.questions-and-answers-center-img {
		width: 16px;
		margin-right: 6px;
	}

	.questions-and-answers-center-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.questions-and-answers-center-sidebar-title {
		width: 100%;
		color: #222222;
		font-size: 15px;
		font-weight: bold;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		margin-bottom: 6px;
	}

	.questions-and-answers-center-sidebar-msg {
		width: 100%;
		color: #777777;
		font-size: 13px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		margin-bottom: 5px;
	}

	.questions-and-answers-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 4px;
	}

	.questions-and-answers-bottom-left {
		display: flex;
		align-items: center;
		color: #666666;
		font-size: 11px;
	}

	.questions-and-answers-bottom-left>img {
		width: 16px;
		margin-right: 6px;
	}

	.questions-and-answers-bottom-right>img {
		width: 14px;
	}

	.item-name3 {
		width: 100%;
		color: #333333;
		font-size: 16px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		font-weight: bold;
		margin-bottom: 8px;
		/* 	font-weight: bold; */
		/* margin-bottom: 5px; */
	}

	.img-box4 {
		width: 120px;
		height: 67px;
		border-radius: 6px;
		overflow: hidden;
		position: relative;
		margin-right: 10px;
	}

	.img-box4 .img {
		width: 100%;
		height: 100%;
	}

	.item-sidebar4 {
		flex: 1;
		min-height: 67px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-bottom-image2 {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 10px;
		padding-top: 10px;
		border-top: 1px solid #F2F2F2;
		box-sizing: border-box;
	}

	.item-bottom-image2-left {
		display: flex;
		align-items: center;
	}

	.item-bottom-image2-right {
		color: #222222;
		font-size: 12px;
	}

	.item-bottom-image2-right>span {
		color: #FF4954;
		font-size: 16px;
		font-weight: bold;
	}

	.location-row {
		display: flex;
		align-items: center;
		font-size: 10px;
		color: #999999;
	}

	.location-row>img {
		width: 10px;
		margin-right: 6px;
	}

	.item-top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	.item-top-name {
		flex: 1;
		font-size: 16px;
		font-weight: bold;
		color: #222222;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.item-top-price {
		color: #FF6700;
		font-size: 14px;
		font-weight: bold;
	}

	.item-top-msg {
		width: 100%;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		font-size: 12px;
		color: #666666;
		margin-bottom: 9px;
	}

	.item-bottom-image3 {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 6px;
		padding-top: 10px;
		border-top: 1px solid #F2F2F2;
		box-sizing: border-box;
	}

	.img-box-tag {
		position: absolute;
		top: 6px;
		left: 6px;
		padding: 0 5px;
		height: 20px;
		line-height: 20px;
		background-color: #FFAF18;
		border-radius: 3px;
		font-size: 12px;
		color: #FFFFFF;

	}

	.list-product {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 12px 0;
		box-sizing: border-box;
	}

	.list-product>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		background-color: #FFFFFF;
		padding: 0 10px;
		box-sizing: border-box;
		border-radius: 10px;
		padding: 10px;
		box-sizing: border-box;
	}

	.img-box-product {
		width: 110px;
		height: 110px;
		position: relative;
		border-radius: 6px;
		overflow: hidden;
		margin-right: 10px;
	}

	.img-box-product .img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.img-box-product-sidebar {
		flex: 1;
		height: 110px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.img-box-product-sidebar-title {
		width: 100%;
		line-height: 22px;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		font-size: 16px;
		font-weight: bold;
		color: #222222;
	}

	.img-box-product-sidebar-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.img-box-product-sidebar-between-row {
		display: flex;
		flex-direction: column;
	}

	.img-box-product-price {
		color: #FF4954;
		font-size: 12px;
		font-weight: bold;
	}

	.img-box-product-price>span {
		font-size: 18px;
	}

	.img-box-product-sale {
		color: #999999;
		font-size: 10px;
		margin-top: 2px;
	}

	.img-box-product-cart {
		width: 24px;
	}

	.img-box-status {
		color: #FFF044;
		font-size: 11px;
		height: 20px;
		line-height: 20px;
		padding: 0 6px;
		background: rgba(0, 0, 0, 0.8);
		position: absolute;
		right: 4px;
		bottom: 4px;
	}

	.img-box-status.green {
		color: #34C759;
	}
</style>
